var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.3478 25.8164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 25.8164,
    opacity: 0,
    width: 19.3478,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4649 5.19141C14.8829 5.19141 16.0196 4.05469 16.0196 2.63672C16.0196 1.23047 14.8829 0.09375 13.4649 0.09375C12.047 0.09375 10.9102 1.23047 10.9102 2.63672C10.9102 4.05469 12.047 5.19141 13.4649 5.19141ZM9.15243 25.8164C14.2618 25.8164 17.672 22.4062 17.672 17.2969C17.672 14.6133 16.3946 13.043 14.004 13.043L12.4337 13.043C12.1642 13.043 11.9884 12.8672 12.0938 12.5391L13.172 9.26953C13.6642 7.76953 12.961 6.41016 11.297 5.98828L6.45712 4.76953C5.98837 4.65234 5.63681 4.73438 5.21493 4.98047L0.515713 7.62891C-0.0350678 7.94531-0.163974 8.75391 0.222745 9.26953C0.597745 9.79688 1.26571 9.89062 1.86337 9.58594L6.17587 7.30078L8.6954 7.96875C9.18759 8.10938 9.37509 8.44922 9.21103 8.90625L7.88681 12.6211C7.27743 14.3672 8.30868 15.8555 9.99618 15.8555L14.3556 15.8555C15.2579 15.8555 15.8907 16.3945 15.8907 17.2969C15.8907 21.3398 13.2071 24.0352 9.16415 24.0352C5.12118 24.0352 2.41415 21.3398 2.41415 17.2969C2.41415 15.9023 2.82431 14.6836 3.50399 13.6641C4.26571 12.5273 2.75399 11.5781 1.95712 12.7734C1.13681 14.0273 0.632901 15.5625 0.632901 17.2969C0.632901 22.4062 4.03134 25.8164 9.15243 25.8164ZM17.7071 25.8164C18.422 25.8164 18.9962 25.2422 18.9962 24.5273C18.9962 23.8125 18.422 23.2383 17.7071 23.2383C16.9923 23.2383 16.4181 23.8125 16.4181 24.5273C16.4181 25.2422 16.9923 25.8164 17.7071 25.8164Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureroll);
export default __webpack_public_path__ + "static/media/figure.roll.299676bb03dd4fd4ba8c02bc76d2f3e8.svg";
export { ForwardRef as ReactComponent };